import CostFieldProto from "./cost-proto";

export default class CostInternalField extends CostFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.COST_INTERNAL;
        this.formulaCompatible = true;
    }

    static getValue(item) {
        return item.costInternal
    }

    get sortHintMessage() {
        return 'Sort by Cost, Internal';
    }

    getCsvValue(item) {
        return CostInternalField.getValue(item);
    }

    getValue(item) {return CostInternalField.getValue(item)}

    listItemSortFunctions(sort) {
        return {
            functions: [i => CostInternalField.getValue(i.item) || 0],
            directions: [sort]
        }
    }
}